export const environment = {
  production: false,
  apiUrl: 'https://api-test.ttologistics.online/api',
  fileUrl: 'https://api-test.ttologistics.online/'
};
